import React from 'react';
import { Card, Row, Col, Typography } from 'antd';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';




// Data for Charts
const arrivalData = [
    { date: 'Nov 1', early: 20, late: 15, leave: 5, holiday: 10 },
    { date: 'Nov 2', early: 25, late: 10, leave: 7, holiday: 12 },
    { date: 'Nov 3', early: 23, late: 12, leave: 8, holiday: 15 },
    { date: 'Nov 4', early: 22, late: 14, leave: 5, holiday: 20 },
    { date: 'Nov 5', early: 18, late: 9, leave: 6, holiday: 25 },
];

const workFromHomeData = [
    { date: 'Nov 1', wfh: 10, holiday: 10 },
    { date: 'Nov 2', wfh: 12, holiday: 12 },
    { date: 'Nov 3', wfh: 15, holiday: 15 },
    { date: 'Nov 4', wfh: 13, holiday: 20 },
    { date: 'Nov 5', wfh: 14, holiday: 25 },
];

const EmployeePresent: React.FC = () => {
    return (
        <div>

            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Card title="Employees' Arrival Stats">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={arrivalData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="early" name="Early On-Time Arrival" fill="#52c41a" />
                                <Bar dataKey="late" name="Late Arrival" fill="#fa8c16" />
                                <Bar dataKey="leave" name="On Leave" fill="#722ed1" />
                                <Bar dataKey="holiday" name="Holiday/Week-Off" fill="#1890ff" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>

                <Col xs={24} md={12}>
                    <Card title="Work from Home/OD Stats">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={workFromHomeData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="wfh" name="Work from Home" fill="#52c41a" />
                                <Bar dataKey="holiday" name="Holiday/Week-Off" fill="#722ed1" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default EmployeePresent;
